import { Fragment } from "react";
import "./AbsenceOverview.css";
import {
    collectAbsenceDaysForEmployee,
    formatHoursMinutes,
    HOLIDAY_TYPE
} from "./absenceOverviewUtils";

function formatDaysAndHours(days, minutes) {
    return days + " / " + formatHoursMinutes(minutes);
}

function AbsenceYearSummary(props) {
    const { employees, selectedYear, selectedTypes, absenceTypes } = props;

    const typesToShow = absenceTypes.filter(absenceType =>
        absenceType !== HOLIDAY_TYPE
        && (selectedTypes.length === 0 || selectedTypes.includes(absenceType))
    );
    const showHolidays = selectedTypes.length === 0 || selectedTypes.includes(HOLIDAY_TYPE);

    const rows = employees.map(employee => {
        const valuesByTypeAndPaid = {};
        let totalDays = 0;
        let totalMinutes = 0;
        let holidayDays = 0;
        let holidayMinutes = 0;

        collectAbsenceDaysForEmployee(employee, selectedYear, null, selectedTypes).forEach(absenceDay => {
            if (absenceDay.type === HOLIDAY_TYPE) {
                holidayDays += 1;
                holidayMinutes += absenceDay.minutes;
                return;
            }

            const key = absenceDay.type + (absenceDay.paid ? "|paid" : "|unpaid");
            if (!valuesByTypeAndPaid[key]) {
                valuesByTypeAndPaid[key] = { days: 0, minutes: 0 };
            }
            valuesByTypeAndPaid[key].days += 1;
            valuesByTypeAndPaid[key].minutes += absenceDay.minutes;

            // Feiertage werden angezeigt, zählen aber nicht in die Gesamtsumme.
            totalDays += 1;
            totalMinutes += absenceDay.minutes;
        });

        return {
            employee,
            valuesByTypeAndPaid,
            totalDays,
            totalMinutes,
            holidayDays,
            holidayMinutes
        };
    });

    if (employees.length === 0) {
        return <p>Keine Mitarbeiter für die aktuelle Auswahl.</p>;
    }

    return (
        <>
            <p className="absences-overview-note">
                Werte als „Tage / Stunden“. Feiertage werden separat ausgewiesen und zählen nicht in die Gesamtsumme.
            </p>
            <div className="absences-overview-table-wrapper">
                <table className="absences-overview-table">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="absences-overview-employee-column">Mitarbeiter</th>
                            {typesToShow.map(absenceType => (
                                <th key={absenceType} colSpan={2} className="absences-overview-group-header">
                                    {absenceType}
                                </th>
                            ))}
                            {showHolidays && <th rowSpan={2}>Feiertage</th>}
                            <th colSpan={2} className="absences-overview-group-header">Gesamt</th>
                        </tr>
                        <tr>
                            {typesToShow.map(absenceType => (
                                <Fragment key={absenceType}>
                                    <th>bezahlt</th>
                                    <th>unbezahlt</th>
                                </Fragment>
                            ))}
                            <th>Tage</th>
                            <th>Std.</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(row => (
                            <tr key={row.employee.employeeId}>
                                <th className="absences-overview-employee-column">
                                    {row.employee.firstName} {row.employee.lastName}
                                </th>
                                {typesToShow.map(absenceType => {
                                    const paid = row.valuesByTypeAndPaid[absenceType + "|paid"] || { days: 0, minutes: 0 };
                                    const unpaid = row.valuesByTypeAndPaid[absenceType + "|unpaid"] || { days: 0, minutes: 0 };

                                    return (
                                        <Fragment key={absenceType}>
                                            <td>{formatDaysAndHours(paid.days, paid.minutes)}</td>
                                            <td>{formatDaysAndHours(unpaid.days, unpaid.minutes)}</td>
                                        </Fragment>
                                    );
                                })}
                                {showHolidays && <td>{formatDaysAndHours(row.holidayDays, row.holidayMinutes)}</td>}
                                <td className="absences-overview-total">{row.totalDays}</td>
                                <td className="absences-overview-total">{formatHoursMinutes(row.totalMinutes)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default AbsenceYearSummary;
